<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">نوت های گواهی نامه</h5>
    <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> نوت </label>
        <select [(ngModel)]="Seleted_Note_Id" name="Seleted_Note_Id" class="custom-select">
          <option value="">انتخاب کنید</option>
          <option *ngFor="let item of DataList_CertificateNote|filter:Filter_Dsc:'dsc'" value="{{item.id}}">{{item.dsc}}</option>

        </select>
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">جستجوی نوت</label>
        <input [(ngModel)]="Filter_Dsc" (keyup)="Change_Filter_title()" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
      </div>

    </div>
    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" (click)="SubmitCertificate()" type="button" [disabled]="!Seleted_Note_Id" class="btn btn-success"
      style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن نوت </button>

    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>کد</th>
            <th>متن</th>

            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Selected_DataList_CertificateNote">
            <td>{{Selected_DataList_CertificateNote.indexOf(item)+1}}</td>
            <td>{{item.code}}</td>
            <td>{{item.dsc}}</td>
            <td>
              <button type="button" class="btn btn-danger" (click)="DeleteCertificateNote(item.id)"> حذف </button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>